<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.89474 15.8571V28.1905H9.73684V15.8571H3.89474ZM15.5789 15.8571V28.1905H21.4211V15.8571H15.5789ZM0 37H37V31.7143H0V37ZM27.2632 15.8571V28.1905H33.1053V15.8571H27.2632ZM18.5 0L0 8.80952V12.3333H37V8.80952L18.5 0Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
const props = defineProps({
  width: {
    type: [String, Number],
    default: 37,
  },
  height: {
    type: [String, Number],
    default: 37,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>